import { RowClassParams } from 'ag-grid-community';

export const getRowClassStyle = (params: RowClassParams, mode: string): string | string[] => {
  if (params.node.rowPinned === 'bottom') {
    return `ag-pin-bottom-row-${mode}`;
  }
  return params.node.rowIndex % 2 === 0 ? 'ag-even-row' : 'ag-odd-row';
};
